(() => {
  // ─── À ajuster ─────────────────────────────────────────────
  // Formulaires suivis (ID visible dans l'URL du formulaire Klaviyo).
  // Tableau vide = tous les formulaires.
  const FORMULAIRES_SUIVIS = ['WW574f'];
  // ───────────────────────────────────────────────────────────

  const EVENEMENTS = {
    open: 'newsletter_popup_affichee',
    submit: 'newsletter_inscription',
    close: 'newsletter_popup_fermee',
    stepSubmit: 'newsletter_etape_validee',
  };

  const pousser = (nom) => {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: nom });
  };

  let delaiEnvoye = false;

  window.addEventListener('klaviyoForms', (e) => {
    const type = e?.detail?.type;
    const nom = EVENEMENTS[type];
    if (!nom) return;
    if (FORMULAIRES_SUIVIS.length && !FORMULAIRES_SUIVIS.includes(e?.detail?.formId)) return;

    pousser(nom);

    if (type === 'open' && !delaiEnvoye) {
      delaiEnvoye = true;
      const secondes = performance.now() / 1000;
      if (secondes <= 10) pousser('newsletter_popup_delai_court');
      else if (secondes <= 30) pousser('newsletter_popup_delai_moyen');
      else pousser('newsletter_popup_delai_long');
    }
  });
})();

/* ────────────────────────────────────────────────────────────────────────────
 * 2. Disponibilité des formulaires Klaviyo
 *
 * Mesure quand la définition des formulaires (`…/forms/api/vN/<compte>/full-forms`)
 * a fini de se télécharger, depuis le début de la navigation. C'est le moment où
 * la popup PEUT s'afficher — bien plus pertinent que `klaviyo.js`, un simple
 * chargeur qui tire ensuite une trentaine de fichiers avant que les formulaires
 * soient prêts. « Absent » = toujours pas disponible après 15 s alors que la page
 * est encore affichée (bloqueur de publicités, erreur réseau…).
 * ──────────────────────────────────────────────────────────────────────────── */
(() => {
  // ─── À ajuster ─────────────────────────────────────────────
  const MOTIF_SCRIPT = /klaviyo\.com\/forms\/api\/v\d+\/[^/]+\/full-forms/;
  const SEUIL_RAPIDE_MS = 3000;
  const SEUIL_MOYEN_MS = 6000;
  const DELAI_ABSENT_MS = 15000;
  // ───────────────────────────────────────────────────────────

  if (!('PerformanceObserver' in window)) return;

  let envoye = false;
  const envoyer = (nom) => {
    if (envoye) return;
    envoye = true;
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: nom });
  };

  const classer = (ms) => {
    if (ms <= SEUIL_RAPIDE_MS) return 'klaviyo_formulaires_rapide';
    if (ms <= SEUIL_MOYEN_MS) return 'klaviyo_formulaires_moyen';
    return 'klaviyo_formulaires_lent';
  };

  let observateur = null;

  // `responseEnd` reste disponible sur une ressource d'un autre domaine, même
  // sans en-tête Timing-Allow-Origin.
  const traiter = (entrees) => {
    const script = entrees.find((entree) => MOTIF_SCRIPT.test(entree.name));
    if (!script) return false;
    envoyer(classer(script.responseEnd));
    if (observateur) observateur.disconnect();
    return true;
  };

  if (traiter(performance.getEntriesByType('resource'))) return;

  // L'observateur reçoit aussi les ressources arrivées après la saturation du
  // tampon de performance, que getEntriesByType ne renverrait plus.
  observateur = new PerformanceObserver((liste) => traiter(liste.getEntries()));
  observateur.observe({ type: 'resource', buffered: true });

  window.setTimeout(() => {
    if (envoye) return;
    observateur.disconnect();
    if (document.visibilityState === 'visible') envoyer('klaviyo_formulaires_absent');
  }, DELAI_ABSENT_MS);
})();

/* ────────────────────────────────────────────────────────────────────────────
 * 3. Performance de la page (seuils des Core Web Vitals de Google)
 *
 *   TTFB  bon ≤ 800 ms   | moyen ≤ 1 800 ms  | mauvais au-delà
 *   LCP   bon ≤ 2 500 ms | moyen ≤ 4 000 ms  | mauvais au-delà
 *   CLS   bon ≤ 0,1      | moyen ≤ 0,25      | mauvais au-delà
 *
 * TTFB : envoyé dès l'exécution, aucun risque de perte. Sensible à l'éventuelle
 * absence de cache du thème servi en prévisualisation.
 * LCP : figé à la première interaction, ou à 10 s.
 * CLS : figé à 15 s. Les décalages qui suivent une interaction (filtres AJAX,
 * par exemple) sont exclus, conformément à la définition officielle.
 *
 * Ces deux derniers ne sont donc mesurés que pour les visiteurs restés assez
 * longtemps ou ayant interagi — biais identique dans les deux bras. L'INP n'est
 * pas mesuré : sa valeur n'est connue qu'à la sortie de page, moment où l'envoi
 * de l'événement n'est pas garanti.
 * ──────────────────────────────────────────────────────────────────────────── */
(() => {
  if (!('PerformanceObserver' in window)) return;

  const pousser = (nom) => {
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: nom });
  };

  const tranche = (valeur, bon, moyen) => {
    if (valeur <= bon) return 'bon';
    if (valeur <= moyen) return 'moyen';
    return 'mauvais';
  };

  // TTFB
  const navigation = performance.getEntriesByType('navigation')[0];
  if (navigation && navigation.responseStart > 0) {
    pousser(`perf_ttfb_${tranche(navigation.responseStart, 800, 1800)}`);
  }

  // LCP : on garde la dernière candidate, figée à la première interaction.
  let lcp = 0;
  let lcpEnvoye = false;
  let observateurLcp = null;
  try {
    observateurLcp = new PerformanceObserver((liste) => {
      const entrees = liste.getEntries();
      if (entrees.length) lcp = entrees[entrees.length - 1].startTime;
    });
    observateurLcp.observe({ type: 'largest-contentful-paint', buffered: true });
  } catch (erreur) {
    observateurLcp = null;
  }

  const envoyerLcp = () => {
    if (lcpEnvoye || !observateurLcp || !lcp) return;
    lcpEnvoye = true;
    observateurLcp.disconnect();
    pousser(`perf_lcp_${tranche(lcp, 2500, 4000)}`);
  };
  ['pointerdown', 'keydown'].forEach((type) => {
    window.addEventListener(type, envoyerLcp, { once: true, capture: true });
  });
  window.setTimeout(envoyerLcp, 10000);

  // CLS : plus grande « fenêtre de session » (décalages espacés de moins de
  // 1 s, fenêtre limitée à 5 s), comme la bibliothèque web-vitals de Google.
  let cls = 0;
  let fenetre = 0;
  let debutFenetre = 0;
  let dernierDecalage = 0;
  let observateurCls = null;
  try {
    observateurCls = new PerformanceObserver((liste) => {
      for (const decalage of liste.getEntries()) {
        if (decalage.hadRecentInput) continue;
        const continuite = fenetre
          && decalage.startTime - dernierDecalage < 1000
          && decalage.startTime - debutFenetre < 5000;
        if (continuite) {
          fenetre += decalage.value;
        } else {
          fenetre = decalage.value;
          debutFenetre = decalage.startTime;
        }
        dernierDecalage = decalage.startTime;
        cls = Math.max(cls, fenetre);
      }
    });
    observateurCls.observe({ type: 'layout-shift', buffered: true });
  } catch (erreur) {
    observateurCls = null;
  }

  window.setTimeout(() => {
    if (!observateurCls) return;
    observateurCls.disconnect();
    pousser(`perf_cls_${tranche(cls, 0.1, 0.25)}`);
  }, 15000);
})();

/* ────────────────────────────────────────────────────────────────────────────
 * 4. Temps passé sur les pages collection
 *
 * Paliers temps_page_005s, _010s, _015s… Le chronomètre ne compte que le TEMPS
 * ACTIF : il se met en pause dès que l'onglet passe en arrière-plan, sinon les
 * onglets oubliés fausseraient tout.
 * ──────────────────────────────────────────────────────────────────────────── */
(() => {
  // ─── À ajuster ─────────────────────────────────────────────
  const PAGES = [/^\/collections\//]; // pages concernées
  const PAS_FIN = 5; // pas sur la partie fine
  const SEUIL_BASCULE = 30; // jusqu'où on reste fin
  const PAS_LARGE = 10; // pas au-delà
  const MAX_S = 120; // dernier palier
  const PREFIXE = 'temps_page_';
  // ───────────────────────────────────────────────────────────

  if (!PAGES.some((motif) => motif.test(window.location.pathname))) return;

  // 5, 10, 15, 20, 25, 30, puis 40, 50 … MAX_S
  const paliers = [];
  for (let s = PAS_FIN; s <= SEUIL_BASCULE; s += PAS_FIN) paliers.push(s);
  for (let s = SEUIL_BASCULE + PAS_LARGE; s <= MAX_S; s += PAS_LARGE) paliers.push(s);

  // File d'attente consommée par Intelligems à son chargement : pas besoin
  // d'attendre `ig:ready`, un événement poussé avant n'est pas perdu.
  window.igEvents = window.igEvents || [];

  let tempsActifMs = 0;
  let dernierTop = document.visibilityState === 'visible' ? Date.now() : null;
  let prochain = 0; // index du prochain palier à franchir
  let minuteur = null;

  const controler = () => {
    if (dernierTop !== null) {
      tempsActifMs += Date.now() - dernierTop;
      dernierTop = Date.now();
    }

    // Les paliers sont croissants : on avance tant que le seuil est franchi.
    while (prochain < paliers.length && tempsActifMs >= paliers[prochain] * 1000) {
      const secondes = String(paliers[prochain]).padStart(3, '0');
      window.igEvents.push({ event: `${PREFIXE}${secondes}s` });
      prochain += 1;
    }

    if (prochain >= paliers.length && minuteur !== null) {
      window.clearInterval(minuteur); // dernier palier atteint, plus rien à surveiller
      minuteur = null;
    }
  };

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      dernierTop = Date.now();
    } else {
      controler();
      dernierTop = null;
    }
  });

  minuteur = window.setInterval(controler, 1000);
})();
